<template>
  <div>
    <div v-if="!emailInactived">
      <ui-heading tag="h4" bold bullet margin>{{
        $t("signInTitle")
        }}</ui-heading>
      <ui-v :rules="rules" ref="login-form">
        <ui-input :autofocus="true" name="email" ref="emailInput" @keyup.enter.native="doLogin" type="email" v-model="user.email" :placeholder="$t('typeEmailHere')">
          <ui-icon name="icon-idcard" slot="prefix"></ui-icon>
        </ui-input>
        <ui-input name="password" @keyup.enter.native="doLogin" v-model="user.password" type="password" :placeholder="$t('typePasswordHere')">
          <ui-icon name="lock" slot="prefix"></ui-icon>
        </ui-input>
      </ui-v>
      <div class="mb20"></div>
      <ui-button full shadow type="primary" :loading="loading" @click.native="doLogin">{{ $t("signin") }}</ui-button>
      <div class="mb20"></div>
      <p @click="authenticate('google')" class="pointer">
        <ui-icon name="google" color="#E8453C"></ui-icon>Sign in using Google
      </p>
      <p>
        <router-link to="forgotPassword">{{
          $t("forgotPassword")
          }}</router-link>
      </p>
    </div>
    <activation-form v-else :email="user.email" @skip-success="emailInactived = false">
    </activation-form>
  </div>
</template>
<script>
import api from "../../api/index";
import ActivationForm from "./ActivationForm.vue";
import { renderProviderLink } from "../../utils/utils.js";
import config from "../../config.js";
const siteConfig = config[process.env.NODE_ENV];
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      siteConfig: siteConfig,
      googleBtnLoading: false,
      loading: false,
      emailInactived: false,
      rules: {
        email: [{
            type: "required",
            trigger: "submit",
            message: this.$t("typeEmailHere")
          },
          {
            type: "email",
            trigger: "submit",
            message: this.$t("typeValidEmail")
          }
        ],
        password: [{
          type: "required",
          trigger: "submit",
          message: this.$t("empty") + this.$t("password")
        }]
      },
      user: {
        email: "",
        password: ""
        // skipActive: false
      }
    };
  },
  components: {
    ActivationForm
  },
  computed: {
    ...mapGetters(['authInfo'])
  },
  methods: {
    authenticate(provider) {
      this.googleBtnLoading = true;
      window.location.href = renderProviderLink(provider);
    },
    skipActive() {
      // this.user.skipActive = true;
      // this.login();
    },
    doLogin() {
      this.$refs["login-form"]
        .validate()
        .then(() => {
          this.login();
        })
        .catch(err => {});
    },
    login() {
      this.loading = true;
      let user = {
        email: this.user.email,
        password: this.user.password
        // skipActive: this.user.skipActive
      };
      this.$store.dispatch('login', user).then(userInfo => {
        if (userInfo.lang) {
          this.$i18n.locale = userInfo.lang;
        }
        if (userInfo.status) {
          localStorage.removeItem("email");
          if (!userInfo.username) {
            this.$router.push("/profile/firstSetting");
          } else {
            if (this.$route.query.go) {
              this.$router.push(this.$route.query.go);
            } else {
              this.$router.go(-1);
            }
          }
        } else {
          this.emailInactived = true;
        }
        this.loading = false;
      }).catch(err => {
        if (err.response.data && err.response.data.errorMsg) {
          if (err.response.data.errorMsg == "wrongPassword") {
            this.$refs["login-form"].parseError({
              name: "password",
              message: this.$t("wrongPassword")
            });
          }
          if (err.response.data.errorMsg == "noSuchUser") {
            this.$refs["login-form"].parseError({
              name: "email",
              message: this.$t("noSuchUser")
            });
          }
        }
        this.loading = false;

      })
    }
  },
  mounted() {
    if (localStorage.getItem("email")) {
      this.$nextTick(() => {
        this.user.email = localStorage.getItem("email");
      });
    }
  }
};

</script>
